export const STORAGE_KEYS = {
  ELEMENTS: "elements",
  FILENAMES: "filenames",
  SKININI: "skinini",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
